export default __webpack_public_path__ + "static/media/frame.950b781d.obj";